import { render, staticRenderFns } from "./BaseS3FileDownloadButton.vue?vue&type=template&id=4cbbb684"
import script from "./BaseS3FileDownloadButton.vue?vue&type=script&lang=js"
export * from "./BaseS3FileDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./BaseS3FileDownloadButton.vue?vue&type=style&index=0&id=4cbbb684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports